module.exports = __webpack_public_path__ + "static/media/termopary4kz.8ea4683c.pdf";